<template>
  <div class="edit" v-if="userInfo">
    <div class="edit__changing-profile" :class="{'edit__hidden': !editProfile}">
      <div class="edit__photo-block">
        <div class="edit__photo ">
          <img class="edit__photo-img" v-if="userInfo.logoUrl" :src="apiImg + userInfo.logoUrl">
        </div>
        <label class="edit__change-image">Изменить<input type="file" class="hidden" @change="saveLogo($event)"></label>
      </div>
      <form class="edit__data" autocomplete="off">
        <label class="edit__item">
          <p class="edit__item-caption">Фамилия</p>
          <input class="edit__item-input" v-model="userInfo.fname" type="text" placeholder="Тарасов"  autocomplete="off">
        </label>
        <label class="edit__item">
          <p class="edit__item-caption">Имя</p>
          <input class="edit__item-input" v-model="userInfo.iname" type="text" placeholder="Александр"  autocomplete="off">
        </label>
        <label class="edit__item">
          <p class="edit__item-caption">Отчество</p>
          <input class="edit__item-input" v-model="userInfo.oname" type="text" placeholder="Владимирович"  autocomplete="off">
        </label>
        <label class="edit__item">
          <p class="edit__item-caption">Email</p>
          <input class="edit__item-input" v-model="userInfo.email" type="text" placeholder="Владимирович"  autocomplete="off">
        </label>
        <!-- Выключает автозаполнение -->
        <input type="text" readonly display="none"  v-show="this.userRoles == 'Student'">
        <label class="edit__item" v-show="this.userRoles == 'Student'">
          <p class="edit__item-caption">Учебная группа</p>
          <select class="edit__item-input edit__item-input--select" v-model="userInfo.groupId" autocomplete="off">
            <option value="1">Группа 1</option>
            <option value="2">Группа 2</option>
            <option value="3">Группа 3</option>
          </select>
        </label>

        <!-- <h3 class="edit__sub-heading">Изменить пароль</h3>
              <label class="edit__item">
          <p class="edit__item-caption">Новый пароль</p>
          <input class="edit__item-input" type="password" v-model="resetForm.newPassword" placeholder="Пароль"  autocomplete="off">
        </label>
        <label class="edit__item">
          <p class="edit__item-caption">Подтвердить</p>
          <input class="edit__item-input" type="password" v-model="resetForm.repeatPassword" placeholder="Пароль"  autocomplete="off">
        </label> -->
        <div class="error" v-if="errors.length">
          {{errors}}
        </div>
        <div class="succes" v-if="succes.length">
          {{succes}}
        </div>
        <button class="edit__submit" type="submit" @click.prevent="saveUser">Сохранить</button>
      </form>
    </div>

    <div class="edit__view-profile" :class="{'edit__hidden': editProfile}">
      <img class="edit__view-photo" v-if="userInfo.logoUrl" :src="userInfo.logoUrl">
      <p class="edit__view-name">{{`${userInfo.iname} ${userInfo.fname} ${userInfo.oname}`}}</p>
      <div class="edit__group">
        <p class="edit__group-caption">Учебная группа</p>
        <p class="edit__group-number" v-if="userInfo.group">{{userInfo.group.name}}</p>
      </div>
      <p class="edit__switch" @click.prevent="editProfile = !editProfile">Редактировать профиль</p>
      <a class="edit__logout" @click.prevent="logout">Выйти</a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import "./EditPersonalData.scss";
export default {
  name: "Personal",
  data() {
    return {
      editProfile: false,
      resetForm: {
        email: "",
        newPassword: "",
        repeatPassword: "",
      },
      avatar: "",
      succes: "",
      errors: "",
    }
  },
  methods: {
    ...mapActions({
      logout: "login/logout",
      uploadLogo: "user/uploadLogo",
      updateUser: "user/updateUser",
      changePassword: "user/changePassword",
      getUserInfo: "user/getUserInfo",
    }),
    saveUser() {
      //axios
      this.succes = ""
      if (
        this.resetForm.newPassword !== "" ||
        this.resetForm.repeatPassword !== ""
      )
        if (this.resetForm.newPassword !== this.resetForm.repeatPassword) {
          this.errors = "Пароли не совпадают"
        } else {
          this.resetForm
          this.changePassword(this.resetForm)
        }

      this.updateUser(this.userInfo).then(() => {
        this.succes = "Профиль успешно изменен"
      })
    },
    saveLogo(event) {
      this.uploadLogo(event).then(res => {
        // console.log(res.data)
        this.userInfo.logoUrl = res.data
      })
    }
  },
  computed: {
    ...mapGetters({
      userRoles: "login/userRoles",
      userName: "login/userName",
      userInfo: "user/userInfo",
      apiImg: "apiImg"
    }),
  },
};
</script>
